import { Pipe, PipeTransform } from "@angular/core";
import { getTemplateTypeDisplayName } from "../models/care-plan-template-types";

@Pipe({
  name: "templateTypeDisplay",
})
export class TemplateTypeDisplayPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return getTemplateTypeDisplayName(value);
  }
}
